//FUNCIONS
import React, { useCallback, useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { routesEndpoints } from '../../../routes/endpoint';
import { StoreState } from '../../../store/createStore';
import { order as onOrder, orderList } from '../../../store/modules/order/actions';

//HOOKS
import { useTranslation } from '../../../hooks/useTranslation';
import { useCheckoutFunction } from '../../../hooks/useCheckoutFunctions';

//TYPES
import { orderListProps, OrderData } from '../../../store/modules/order/types';
import { checkoutActionTypes, cartProductProps } from '../../../store/modules/checkout/types';

//COMPONENTS
import ReactPaginate from 'react-paginate';
import { FiCheck } from 'react-icons/fi';
import { AiOutlineRead, AiOutlineRetweet } from 'react-icons/ai';
import { FaSadTear } from 'react-icons/fa';
import Loading from '../../../components/Loading';

//STYLES
import {
  Container,
  Title,
  ContainerOrdersNoData,
  AskAgainButton,
  ReviewOrderButton,
  ContainerOrders,
  ContainerOrdersRow,
  ContainerOrdersRowBody,
  ContainerOrdersRowLeft,
  ContainerOrdersRowRight,
  ContainerOrdersRowFooter,
  OrderNumber,
  OrderAddresse,
  OrderDataTimeAndAmout,
  OrderStatus,
  OrderStatusTitle,
  OrderStatusStatus,
  OrderStatusIcon,
  StyledPaginateContainer,
} from './styles';
import { RoundHelper } from '../../../utils/roundHelper';

const AccountOrders: React.FC = () => {
  const { orders, loading } = useSelector((state: StoreState) => state.order);
  const { onTranslation: t } = useTranslation();
  const {
    user: {
      data: { id },
    },
  } = useSelector((state: StoreState) => state.auth);

  const dispatch = useDispatch();

  const history = useHistory();

  const { handleCheckoutActions } = useCheckoutFunction();

  useEffect(() => {
    const requestOrder: orderListProps = {
      customer_id: id,
    };
    dispatch(orderList(requestOrder));
  }, [dispatch, id]);

  const handleadOrderShow = useCallback(
    (order: number) => {
      dispatch(onOrder(order));
      history.push(`${routesEndpoints.ORDERS_DETAIL}?id=${order}`);
    },
    [dispatch, history],
  );

  const handleadOrderRemake = useCallback(
    (order: OrderData) => {
      //dispatch(orderByIDRemake(order));
      let newCart = [] as cartProductProps[];
      order.items?.map(item => {
        if (item.additional)
          newCart.push(item.additional)
        return item;
      })
      handleCheckoutActions(checkoutActionTypes.ADD_PLU_CHECKOUT, '', "0", newCart);
    },
    [handleCheckoutActions],
  );

  const onChangePage = useCallback((selectedID: number) => {
    const requestOrder: orderListProps = {
      customer_id: id,
    };
    dispatch(orderList(requestOrder, selectedID + 1));
  }, [dispatch, id]);

  return (
    <Container>
      <Title>
        <span>{t('main.new_account.account_order.my_orders')}</span>
      </Title>
      <ContainerOrders>
        {
          loading && <Loading size={160} bShowText />
        }
        {orders &&
          !loading &&
          orders.orders?.map(order => (
            <ContainerOrdersRow key={order.order_id}>
              <ContainerOrdersRowBody>
                <ContainerOrdersRowLeft>
                  <OrderNumber>
                    <span>{t('main.new_account.account_order.order')} # {order.order_id}</span>
                  </OrderNumber>
                  <OrderAddresse>
                    {order.shipping?.address && order.shipping?.number ? (
                      <>
                        <span>{` ${order.shipping?.address}, ${order.shipping?.number}`}</span>
                      </>
                    ) : (
                      <>
                        <span>{t('main.new_account.account_order.without_address')}</span>
                      </>
                    )}
                  </OrderAddresse>
                  <OrderDataTimeAndAmout>
                    <span> {`${t('main.new_account.account_order.date')} `}
                      {order.created_at &&
                        moment(order.created_at).format(
                          'DD/MM/YYYY HH:mm:ss',
                        )}{' '}
                      - {t('main.new_account.account_order.total')} {RoundHelper.toFormatted(order.grand_total)}</span>
                  </OrderDataTimeAndAmout>
                </ContainerOrdersRowLeft>
                <ContainerOrdersRowRight>
                  <OrderStatus>
                    <OrderStatusTitle><span>{t('main.new_account.account_order.state_order')} </span></OrderStatusTitle>
                    <OrderStatusStatus><span>{order.status_label}</span></OrderStatusStatus>
                    <OrderStatusIcon
                      type={order.status ? order.status : 'payment_approved'}
                    >
                      <FiCheck color="#fff" />
                    </OrderStatusIcon>
                  </OrderStatus>
                </ContainerOrdersRowRight>
              </ContainerOrdersRowBody>
              <ContainerOrdersRowFooter>
                <AskAgainButton
                  onClick={() =>
                    order && handleadOrderRemake(order)
                  }
                >
                  <span>{t('main.new_account.account_order.ask_again')}</span>
                  <AiOutlineRetweet size={25} color="#FFF" />
                </AskAgainButton>
                <ReviewOrderButton
                  onClick={() =>
                    order.order_id && handleadOrderShow(order.order_id)
                  }>
                  <span>{t('main.new_account.account_order.check_order')}</span>
                  <AiOutlineRead size={25} color="#FFF" />
                </ReviewOrderButton>
              </ContainerOrdersRowFooter>
            </ContainerOrdersRow>
          ))
        }

        {
          orders && orders.orders && orders.orders.length > 0 && !loading && (
            <StyledPaginateContainer>
              <ReactPaginate
                previousLabel={t('main.globals.previous')}
                nextLabel={t('main.globals.next')}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={orders.last_page ? orders.last_page : 0}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                forcePage={orders.current_page ? orders.current_page - 1 : 0}
                onPageChange={(selectedPage) => onChangePage(selectedPage.selected)}
                containerClassName={'pagination'}
                activeClassName={'active'}
                previousClassName={orders.current_page === 1 ? 'disabled' : ''}
                nextClassName={orders.current_page === orders.last_page ? 'disabled' : ''}
              />
            </StyledPaginateContainer>
          )
        }

        {!loading && orders && orders.orders?.length === 0 && (
          <ContainerOrdersNoData>
            <span>{t('main.new_account.account_order.without_order')} <FaSadTear color="var(--primary)" size={22} /></span>
          </ContainerOrdersNoData>
        )}
      </ContainerOrders>
    </Container>
  );
}

export default AccountOrders;
